import { types } from 'mobx-state-tree';

import Actions from './Actions';
import Views from './Views';

const BusinessOpportunities = types
  .model({
    firstPromoVisit: types.maybe(types.string),
    newSignals: types.optional(types.number, 0),
    isLoaded: types.optional(types.boolean, false),
    signalsCount: types.optional(types.number, 0),
    displayOpportunities: types.optional(types.boolean, false),
  })
  .views(Views)
  .actions(Actions);

export default BusinessOpportunities;
